'use client';

import { DataTestIdEnum } from '@medprev-web-app/datatestid';

import { CartItemDuplicateWarning } from './cart-item-duplicate-warning.component';
import { CartItemField } from './cart-item-field.component';
import { CartItemProcedure } from './cart-item-procedure.component';
import { CartItemRemoveButton } from './cart-item-remove-button.component';
import { CartItemScheduleField } from './cart-item-schedule-field.component';
import { CartItemWarning } from './cart-item-warning.component';
import { CartItemProps } from './cart-item.types';

import { hasCartItemCouponDiscount, isPromotionalCartItem } from '@/utils/cart/get-cart-total.util';
import { formatSimpleAddress } from '@/utils/formatters/format-address';
import { formatToTitleCase } from '@/utils/formatters/format-to-title-case';

export function CartItemDetails({
  item,
  warning,
  isDuplicated,
  onEditSchedule,
  onEditPatient,
  onRemove,
}: CartItemProps) {
  const patientName = formatToTitleCase(item.patient.socialName || item.patient.legalName);

  const showsDiscountPill = isPromotionalCartItem(item) || hasCartItemCouponDiscount(item);

  const showLocation = !item.procedure.isTelehealth;
  const locationAddress = formatSimpleAddress(item.partner.facility);

  return (
    <>
      {isDuplicated && <CartItemDuplicateWarning />}

      <CartItemProcedure item={item} />

      {!showsDiscountPill && <hr className="border-t border-gray-300" />}

      <CartItemScheduleField item={item} onEditSchedule={onEditSchedule} />

      {warning && <CartItemWarning>{warning}</CartItemWarning>}

      <CartItemField
        label="Atendimento para"
        value={<span>{patientName}</span>}
        dataTestId={DataTestIdEnum.CART_ITEM_FIELD_PATIENT}
        action={onEditPatient && {
          label: 'Alterar paciente',
          dataTestId: DataTestIdEnum.CART_ITEM_EDIT_PATIENT_BUTTON,
          onClick: onEditPatient,
        }}
      />

      {showLocation && (
        <CartItemField
          label="Local"
          dataTestId={DataTestIdEnum.CART_ITEM_FIELD_LOCATION}
          value={(
            <>
              <span>{formatToTitleCase(item.partner.facility.name)}</span>
              <span>{locationAddress}</span>
            </>
          )}
        />
      )}

      {onRemove && <CartItemRemoveButton onRemove={onRemove} />}
    </>
  );
}
